import { handleFreeReturn } from '@lambda/commons/helpers';
import heartIcon from '@/public/images/about/heart.svg';
import crownIcon from '@/public/images/about/crown.svg';
import protectionIcon from '@/public/images/about/protection.svg';
import earthIcon from '@/public/images/about/earth.svg';
import treeIcon from '@/public/images/about/tree.svg';
import waterIcon from '@/public/images/about/water.svg';
import customerIcon from '@/public/images/about/customer.svg';
import starIcon from '@/public/images/about/star.svg';
import { getEdgeUrl } from '@/lib/getEdgeUrl';
import settings from '@/settings';
import { Breakpoints } from '@/settings/breakpoints';
import i18n from '@/settings/i18n';
import { LeaderT } from './types';

const freeReturnDays = handleFreeReturn(
  settings.store,
  settings.free_return_days,
);

// Descriptions take the page's translator so Buyer Protection can quote the
// store's own return period (RT-17689).
export const VALUES: {
  icon: typeof heartIcon;
  title: string;
  description: (t: ReturnType<typeof i18n.init>) => string;
}[] = [
  {
    icon: heartIcon,
    title: 'Handpicked Professional Sellers',
    description: (t) =>
      t`We work with experienced & trustworthy local sellers who value sustainability and know their craft.`,
  },
  {
    icon: crownIcon,
    title: 'Quality & Transparency',
    description: (t) =>
      t`100% functional, original, & sustainable products, quality checked at 40+ points.`,
  },
  {
    icon: protectionIcon,
    title: 'Buyer Protection',
    description: (t) =>
      t`Free shipping, up to 12 months warranty, ${{
        freeReturnDays,
      }}-day returns, and extended protection with ReebeloCare.`,
  },
];

export const KEY_METRICS = [
  {
    icon: earthIcon,
    title: '5 Tons',
    description: 'Saved e-waste',
    hideMobile: false,
  },
  {
    icon: treeIcon,
    title: '486K',
    description: 'Trees planted (2023)',
    hideMobile: false,
  },
  {
    icon: waterIcon,
    title: '48.7M',
    description: 'Litres water saved',
    hideMobile: false,
  },
  {
    icon: customerIcon,
    title: '500K+',
    description: 'Customers',
    hideMobile: false,
  },
  {
    icon: starIcon,
    title: '30K',
    description: 'Trustpilot reviews',
    hideMobile: true,
  },
];

export const LEADERS: LeaderT[] = [
  {
    image: getEdgeUrl('images/about-us/leaders/philip.png'),
    name: 'Philip Franta',
    postion: 'Co-founder & CEO',
    intro: 'Meet Philip, our founder, CEO, and the intellect behind Reebelo.',
    topPick: {
      image: getEdgeUrl(
        'images/about-us/leaders/top-picks/apple-watch-series-9.png',
      ),
      title: 'Apple Watch Series 9',
      link: '/collections/apple-watch-series-9',
    },
  },
  {
    image: getEdgeUrl('images/about-us/leaders/fabien.png'),
    name: 'Fabien Rastouil',
    postion: 'Co-founder & CPO',
    intro:
      "Meet Fabien, our CPO, driving Reebelo's product vision and innovation for customers and vendors alike.",
    topPick: {
      image: getEdgeUrl(
        'images/about-us/leaders/top-picks/irobot-cacuum-cleaner.png',
      ),
      title: 'iRobot Vacuum Cleaner',
      link: '/collections/irobot-roomba-960-robot-vacuum',
    },
  },
  {
    image: getEdgeUrl('images/about-us/leaders/gulrez.png'),
    name: 'Gulrez Tyebji',
    postion: 'Managing Director APAC',
    intro:
      'Gulrez, Managing Director APAC at Reebelo, drives sales growth and expands business in Australia & NZ.',
    topPick: {
      image: getEdgeUrl('images/about-us/leaders/top-picks/ipad-pro-6.png '),
      title: 'iPad Pro 6 (2022)',
      link: '/collections/ipad-pro-2022-12-9',
    },
  },
];

export const leadersBreakpoints = {
  [Breakpoints.NONE]: {
    slidesPerView: 1,
    slidesPerGroup: 1,
    spaceBetween: 10,
  },
  [Breakpoints.XXXS]: {
    slidesPerView: 1.25,
    slidesPerGroup: 1,
    spaceBetween: 10,
  },
  [Breakpoints.XS]: {
    slidesPerView: 1.75,
    slidesPerGroup: 1,
    spaceBetween: 10,
  },
  [Breakpoints.MD]: {
    slidesPerView: 2.5,
    slidesPerGroup: 1,
    spaceBetween: 10,
  },
  [Breakpoints.LG]: {
    slidesPerView: 3,
    slidesPerGroup: 1,
    spaceBetween: 10,
  },
  [Breakpoints.XL]: {
    slidesPerView: 3,
    slidesPerGroup: 3,
    spaceBetween: 10,
  },
};
